import { render, staticRenderFns } from "./FUN.vue?vue&type=template&id=ae981350"
import script from "./FUN.vue?vue&type=script&lang=js"
export * from "./FUN.vue?vue&type=script&lang=js"
import style0 from "./FUN.vue?vue&type=style&index=0&id=ae981350&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports